import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '../../components/ButtonMC';
import DraggableListMC from '../../components/DraggableListMC';
import CreateFunnelStepItem from './CreateFunnelStepItemMC';
import TitleDescriptionMC from '../../components/TitleDescriptionMC';

const CreateFunnelStepTwo = ({
  data,
  onChange,
  setStep,
  setSelectedItem,
  withFunnelStepsText = true
}) => {
  const { t } = useTranslation('Funnels');

  const handleDragEndSteps = (result, type) => {
    if (!result.destination) {
      return;
    }
    const stepField = type === 'opened' ? 'openSteps' : 'closedSteps';
    const steps = data[stepField];
    const reorderedItems = Array.from(steps);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    onChange(stepField, reorderedItems);
  };

  const onEditFunnelStep = (type, item) => {
    setSelectedItem(item);
    setStep(type === 'openSteps' ? 'stageOpen' : 'stageClosed');
  };

  const onDeleteFunnelStep = (type, item) => {
    const steps = data[type];
    onChange(type, steps.filter((step) => step.id !== item.id));
  };

  const onChangeFunnelStep = (type, item) => {
    const steps = data[type];
    const updatedSteps = steps.map((step) => (step.id === item.id ? { ...item, type_step: type === 'openSteps' ? 'open' : 'closed' } : step));
    onChange(type, updatedSteps);
  };

  const OpenedItem = ({ data: dItem }) => FunnelStepOpenedItem({
    data: dItem,
    onDeleteFunnelStep,
    onEditFunnelStep,
    onChange: onChangeFunnelStep
  });

  const ClosedItem = ({ data: dItem }) => FunnelStepClosedItem({
    data: dItem,
    onDeleteFunnelStep,
    onEditFunnelStep,
    onChange: onChangeFunnelStep
  });

  return (
    <div className="tw-wrapper">
      {withFunnelStepsText && (
        <TitleDescriptionMC
          title={t('sidebar.createFromZero.stepTwo.fields.title')}
          description={t('sidebar.createFromZero.stepTwo.fields.subtitle')}
        />
      )}
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stepTwo.fields.titleOpenSteps')}
        description={t('sidebar.createFromZero.stepTwo.fields.subtitleOpenSteps')}
        className="tw-mt-6"
      />
      {data.openSteps.length > 0 ? (
        <>
          <DraggableListMC
            items={data.openSteps}
            onDragEnd={(e) => handleDragEndSteps(e, 'opened')}
            ItemComponent={OpenedItem}
            className="tw-mt-2"
          />
          <ButtonComponent
            text={t('sidebar.createFromZero.stepTwo.addButton')}
            variant="SECONDARY"
            className="tw-pl-2"
            iconPosition="left"
            icon="plus-outline"
            onClick={() => {
              setSelectedItem({ type_step: 'open' });
              setStep('stageOpen');
            }}
          />
        </>
      ) : (
        <ButtonComponent
          text={t('sidebar.createFromZero.stepTwo.fields.buttonOpenSteps')}
          variant="SECONDARY"
          className="tw-w-full tw-mt-2"
          iconPosition="left"
          icon="plus-outline"
          onClick={() => {
            setSelectedItem({ type_step: 'open' });
            setStep('stageOpen');
          }}
          outlined
        />
      )}

      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stepTwo.fields.titleClosedSteps')}
        description={t('sidebar.createFromZero.stepTwo.fields.subtitleClosedSteps')}
        className="tw-mt-6"
      />

      {data.closedSteps.length > 0 ? (
        <>
          <DraggableListMC
            items={data.closedSteps}
            onDragEnd={(e) => handleDragEndSteps(e, 'closed')}
            ItemComponent={ClosedItem}
            className="tw-mt-2"
          />
          <ButtonComponent
            text={t('sidebar.createFromZero.stepTwo.addButton')}
            variant="SECONDARY"
            className="tw-pl-2"
            iconPosition="left"
            icon="plus-outline"
            onClick={() => {
              setSelectedItem({ type_step: 'closed' });
              setStep('stageClosed');
            }}
          />
        </>
      ) : (
        <ButtonComponent
          text={t('sidebar.createFromZero.stepTwo.fields.buttonClosedSteps')}
          variant="SECONDARY"
          className="tw-w-full tw-mt-2"
          iconPosition="left"
          icon="plus-outline"
          onClick={() => {
            setSelectedItem({ type_step: 'closed' });
            setStep('stageClosed');
          }}
          outlined
        />
      )}
    </div>
  );
};

const FunnelStepOpenedItem = ({
  data,
  onDeleteFunnelStep,
  onEditFunnelStep,
  onChange
}) => (
  <CreateFunnelStepItem
    type="openSteps"
    data={data}
    onPressDelete={onDeleteFunnelStep}
    onPressEdit={onEditFunnelStep}
    onChange={onChange}
  />
);

const FunnelStepClosedItem = ({
  data,
  onDeleteFunnelStep,
  onEditFunnelStep,
  onChange
}) => (
  <CreateFunnelStepItem
    type="closedSteps"
    data={data}
    onPressDelete={onDeleteFunnelStep}
    onPressEdit={onEditFunnelStep}
    onChange={onChange}
  />
);
export default CreateFunnelStepTwo;
